import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { fetchData } from "../../../Components/common/utils";

const Popular_Categories = () => {
  const [categories, setCategories] = useState([]);
  const [productByCategory, setProductByCategory] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryId, setCategoryId] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/trending/product";
      const result = await fetchData(url);

      if (result && result.data) {
        console.log(result.data);

        setProductByCategory(result.data);
        const categoryKeys = Object.keys(result.data);
        setCategories(categoryKeys);
        setSelectedCategory(categoryKeys[0]); // default select first category

        // set categoryId from first product in first category
        const firstProducts = result.data[categoryKeys[0]];
        if (firstProducts && firstProducts.length > 0) {
          setCategoryId(firstProducts[0].category_id);
        }
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);

  const selectCategory = (category) => {
    setSelectedCategory(category);

    // update categoryId if products exist
    const products = productByCategory[category];
    if (products && products.length > 0) {
      setCategoryId(products[0].category_id);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <h1 className="text-center p-4 my-4">Trending Items</h1>
        <div className="row">
          {[1, 2, 3, 4].map((_, i) => (
            <div className="col-md-3 col-sm-12 mb-2" key={i}>
              <div className="placeholder-glow">
                <span
                  style={{ height: "10em" }}
                  className="col-12 placeholder"
                ></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="text-center p-4 my-4">Trending Items</h1>

      {/* Category Tabs */}
      <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 my-5">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`tabs-btns ${selectedCategory === category ? "active" : ""
              }`}
            onClick={() => selectCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Products */}
      <div className="row">
        {productByCategory[selectedCategory]?.map((details, index) => (
          <div className="col-md-3 mb-3" key={index}>
            <NavLink
              to={
                details?.varient?.length !== 0
                  ? `${details?.parent_category_title}/${details?.category_title}/${details.slug}`
                  : `${details?.parent_category_title}/${details?.category_title}/detail/${details.slug}`
              }
            >
              <div className="card h-100">
                <div className="card-img-wrapper">
                  <img
                    className="latest-product-img"
                    src={details.media[0].original_url}
                    alt={details.title}
                  />
                </div>
                <div className="card-body text-center">
                  <h6 className="card-title text-center">{details.title}</h6>
                  {details?.parent_category_title === 'solar' || details?.parent_category_title === 'Solar' 
                  || details?.parent_category_title ===  'Electronics' || details?.parent_category_title === 'electronics' ? (
                    <strong className="dollar">
                      {details.price}
                    </strong>
                  ) : (
                    <strong className="dollar">
                      {details.price_start}{" "}
                      {details.price_end === null ? "" : "-" + details.price_end}
                    </strong>
                  )}

                </div>
              </div>
            </NavLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular_Categories;
